import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InfoMessageItem } from '../model/infomessage';
import { APIService } from './api.service';
import { ReturnObject } from '../model/returnobject';

@Injectable({
    providedIn: 'root'
})
export class InfoMessageService {

    constructor(private api: APIService){
    }

    setInfoMessage(infoMessage: InfoMessageItem ): Observable<ReturnObject<string>> {
        return this.api.postAPI(`infomessage`, infoMessage);
    }

    getMessages(): Observable<ReturnObject<InfoMessageItem[]>> {
        return this.api.getAPI(`infomessage`);
    }

    getActiveAndScheduledMessages(): Observable<ReturnObject<InfoMessageItem[]>> {
        return this.api.getAPI(`infomessage/getactiveandscheduledmessages`);
    }

    deleteMessage(msgid: number): Observable<ReturnObject<string>>{
        return this.api.deleteByEndpointAPI(`infomessage`, msgid);
    }
}
